import { render } from "./IconNoticeTriangle.vue?vue&type=template&id=2de32422"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconNoticeTriangle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2de32422"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2de32422', __exports__)) {
    api.reload('2de32422', __exports__)
  }
  
  module.hot.accept("./IconNoticeTriangle.vue?vue&type=template&id=2de32422", () => {
    api.rerender('2de32422', render)
  })

}


export default __exports__